import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { CreateAccountRoutingModule } from './create-account-routing.module';
import { CreateAccountComponent } from './create-account.component';
import { CreateAccountResolve } from './create-account.resolve';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { MatStepperModule } from "@angular/material/stepper";
import { HttpClientModule } from "@angular/common/http";
import { NgxStripeModule } from 'ngx-stripe';
import {StripeModule} from "../../shared/stripe/stripe.module";
import { AccountComponent } from './account/account.component';
import { BrandsComponent } from './brands/brands.component';
import { PaymentComponent } from './payment/payment.component';
import { PaymentOptionsComponent } from './payment-options/payment-options.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
    NgxMaskModule.forRoot(),
    SharedModule,
    CreateAccountRoutingModule,
    MatStepperModule,
    HttpClientModule,
    NgxStripeModule.forRoot(),
    StripeModule,
    NgOptimizedImage
  ],
    declarations: [CreateAccountComponent, AccountComponent, BrandsComponent, PaymentComponent, PaymentOptionsComponent],
    exports: [CreateAccountComponent],
    providers: [CreateAccountResolve]
})
export class CreateAccountModule {}
